import { Action, createReducer, on } from '@ngrx/store';
import {
  loadSubscriptionDetails,
  loadSubscriptions,
  paginateSubscriptions,
} from 'src/actions/subscription/subscriptions.action';

export const initialState: any = {
  fetching: false,
  data: {
    subscriptions: [],
    totalDocuments: 0,
  },
};

const subscriptionsReducer = createReducer(
  initialState,

  // Subscriptions List
  on(loadSubscriptions, (state, response) => ({
    ...state,
    data: {
      ...state.data,
      subscriptions: response?.data ?? [],
      totalDocuments: response?.metaData?.totalDocuments ?? 0,
    },
  })),

  // Subscription Details
  on(loadSubscriptionDetails, (state, payload: any) => ({
    ...state,
    data: {
      ...state.data,
      data: payload,
    },
  })),

  // Subscriptions List Pagination
  on(paginateSubscriptions, (state) => state)
);

export function reducer(state: any, action: Action): any {
  return subscriptionsReducer(state, action);
}
